import script from "./PaymentHistoryTableDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentHistoryTableDetails.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentHistoryTableDetails.vue?vue&type=style&index=0&id=f2f97e54&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2f97e54"]])

export default __exports__